import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BannerStyles = styled.div`
    .cookie-banner {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: white;
        border-top: 1px solid #ccc;
        padding: 14px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 200;
        transform: translateY(100%);
        transition: transform 0.4s ease;
        gap: 16px;
    }

    .cookie-banner.visible {
        transform: translateY(0);
    }

    .cookie-banner-text {
        display: flex;
        align-items: center;
        gap: 10px;
        flex: 1;
    }

    .cookie-banner-text p {
        margin: 0;
        font-family: figtree;
        font-size: 13px;
        color: #707070;
        line-height: 1.4;
    }

    .cookie-banner-dismiss {
        height: 34px;
        padding: 0 18px;
        background-color: #2CE8A3;
        border: 1.5px solid #2CE8A3;
        border-radius: 6px;
        font-family: figtree;
        font-size: 13px;
        cursor: pointer;
        white-space: nowrap;
        flex-shrink: 0;
        transition: background-color 0.2s ease;
    }

    .cookie-banner-dismiss:hover {
        background-color: #E3FFF6;
        border: 1.5px solid #2CE8A3;
    }

    @media (max-width: 575px) {
        .cookie-banner {
            flex-direction: column;
            align-items: flex-start;
            padding: 14px 16px;
            gap: 12px;
        }

        .cookie-banner-dismiss {
            width: 100%;
            height: 38px;
        }
    }
`;

export default function CookieBanner() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const dismissed = sessionStorage.getItem('cookieBannerDismissed');
        if (!dismissed) {
            // Small delay so it slides in after page load
            setTimeout(() => setVisible(true), 800);
        }
    }, []);

    const handleDismiss = () => {
        setVisible(false);
        sessionStorage.setItem('cookieBannerDismissed', 'true');
    };

    return (
        <BannerStyles>
            <div className={`cookie-banner ${visible ? 'visible' : ''}`}>
                <div className="cookie-banner-text">
                    <p>
                        🍪 This site uses essential cookies only to ensure basic functionality. No tracking or advertising cookies are used. See our{' '}
                        <span
                            onClick={() => window.open('https://www.notion.so/Privacy-Policy-2fb9fd4feb7480b6aeaffec54c44fb3d', '_blank')}
                            style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                        >
                            Privacy Policy
                        </span>
                        .
                    </p>
                </div>
                <button className="cookie-banner-dismiss" onClick={handleDismiss}>
                    Got it
                </button>
            </div>
        </BannerStyles>
    );
}